export function getSelectedSceneSlugFromUrl(appUrl: string): string | undefined {
  const sceneSlug = new URL(appUrl).searchParams.get("scene")?.trim();

  return sceneSlug ? sceneSlug : undefined;
}
